import { useQueries } from '@tanstack/react-query';
import { searchSlides } from 'api/slides';

export const useCrossLabSlideSearches = (slideIds: string[], enabled: boolean) =>
  useQueries({
    queries: slideIds.map((slideId) => ({
      queryKey: ['slidesSearch', slideId],
      queryFn: ({ signal }: { signal?: AbortSignal }) => searchSlides(slideId, signal),
      enabled: enabled && slideId !== '',
    })),
  });
